import React, { useRef } from 'react';
import { useTranslation } from 'next-i18next';
import { useOnScreen } from 'src/hooks/useOnScreen';
import Facebook from '../icons/Facebook';
import Insta from '../icons/Insta';
import LinkedIn from '../icons/LinkedIn';
import * as S from './Footer.styles';
const Footer = ({
  Prefooter: PrefooterElement
}) => {
  const {
    t,
    i18n: {
      language
    }
  } = useTranslation();
  const selfRef = useRef(null);
  const Self = /*#__PURE__*/React.createElement(S.Wrapper, {
    ref: selfRef
  }, /*#__PURE__*/React.createElement(S.Content, null, /*#__PURE__*/React.createElement(S.Column, null, /*#__PURE__*/React.createElement(S.Link, {
    href: `https://patient21.com/${language}/impressum`
  }, t('common.footer.imprint')), /*#__PURE__*/React.createElement(S.Link, {
    href: `/${language}/information`
  }, " ", t('common.footer.information')), /*#__PURE__*/React.createElement(S.Link, {
    href: `/${language}/terms`
  }, " ", t('common.footer.tos')), /*#__PURE__*/React.createElement(S.Link, {
    href: `/${language}/contact`
  }, " ", t('common.footer.contact')), /*#__PURE__*/React.createElement(S.Link, {
    href: `/${language}/privacy`
  }, " ", t('common.footer.privacy'))), /*#__PURE__*/React.createElement(S.Column, null, /*#__PURE__*/React.createElement(S.Socials, null, /*#__PURE__*/React.createElement(S.SocialLink, {
    href: "https://www.facebook.com/patient21DOTcom"
  }, /*#__PURE__*/React.createElement(Facebook, null)), /*#__PURE__*/React.createElement(S.SocialLink, {
    href: "https://www.linkedin.com/company/patient21"
  }, /*#__PURE__*/React.createElement(LinkedIn, null)), /*#__PURE__*/React.createElement(S.SocialLink, {
    href: "https://www.instagram.com/patient21_com/"
  }, /*#__PURE__*/React.createElement(Insta, null))), /*#__PURE__*/React.createElement(S.Brand, null, "\xA9 Patient21, ", new Date().getFullYear()))));
  const isVisible = useOnScreen(selfRef, Self);
  const Prefooter = (() => {
    if (!PrefooterElement) return null;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(S.InView, {
      isVisible: isVisible
    }, PrefooterElement), /*#__PURE__*/React.createElement(S.Fixed, {
      isVisible: !isVisible
    }, PrefooterElement));
  })();
  return /*#__PURE__*/React.createElement(React.Fragment, null, Prefooter, Self);
};
export default Footer;